//* Libraries imports
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

//* Components imports
import { ProcessExamList } from "./process-exam-list";
import { ErrorMessages } from "../../../../../../component/common/ErrorMessages";

//* Hooks imports
import { useGetPaginatedProcessExams } from "../../../../../../hooks/queries/process/use-get-paginated-exam";

//* Types imports
import { type PaginatedExam } from "../../../../../../schemas/common/process/exam";

function transformProcessExamData(items: PaginatedExam[]) {
  return items.map((item) => ({
    id: item.id,
    name: item.name,
    totalQuestions: item.totalQuestions,
    disciplinesCount: item.disciplinesCount,
  }));
}

export function ProcessExamTable({ processoId }: { processoId: number }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || ""
  );
  const page = parseInt(searchParams.get("page") || "1", 10);
  const perPage = 10;
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  const Results = useGetPaginatedProcessExams(
    processoId,
    page,
    perPage,
    searchTerm
  );

  useEffect(() => {
    if (Results.isError && Results.error) {
      const error = Results.error as any;      const message =
        typeof error === "string"
          ? error
          : error?.message ||
            "Ocorreu um erro ao buscar os modelos de prova.";
      setErrorMessages([message]);
    }
  }, [Results.isError, Results.error]);

  const clearErrorMessages = () => {
    setErrorMessages([]);
  };

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSearch = () => {
    if (searchTerm.length >= 3 || searchTerm.length === 0) {
      const newSearchParams = new URLSearchParams(searchParams);
      if (searchTerm) {
        newSearchParams.set("search", searchTerm);
      } else {
        newSearchParams.delete("search");
      }
      newSearchParams.set("page", "1");
      setSearchParams(newSearchParams);
    }
  };

  const handlePageChange = (newPage: number) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("page", newPage.toString());
    setSearchParams(newSearchParams);
  };

  // const handleView = (id: number) => {
  //   navigate(`results/${id}`);
  // };

  const handleViewExamResults = (id: number) => {
    navigate(`results/${id}`);
  };

  const transformedItems = Results.data?.data 
    ? transformProcessExamData(Results.data.data)
    : [];

  const totalItems = Results.data?.meta?.totalItems || Results.data?.data?.length || 0;
  const totalPages = Math.ceil(totalItems / perPage);
    const fields = [
    { name: 'name', totalQuestions: 'name', header: 'Nome do Modelo de Prova', type: 'text' as const },
    { name: 'totalQuestions', totalQuestions: 'totalQuestions', header: 'Total de Questões', type: 'text' as const },
    { name: 'disciplinesCount', totalQuestions: 'disciplinesCount', header: 'Disciplinas', type: 'text' as const },
  ];

  return (
    <div className="w-100 p-5">
      <ErrorMessages 
        messages={errorMessages} 
        clearErrors={clearErrorMessages} 
      />      
      
      <ProcessExamList
        title="Modelos de Prova do Processo"
        searchPlaceholder="Pesquisar provas..."
        notFoundMessage="Nenhum modelo de prova encontrado"
        fields={fields}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearch={handleSearch}
        onViewExamResults={handleViewExamResults}
        items={transformedItems}
        loading={Results.isLoading}
        currentPage={page}
        totalPages={totalPages}
        totalItems={totalItems}
        itemsPerPage={perPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
}
